import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';

export const initialValues = {
  editableLineCharges: '',
  allowPolicyEndDateEdits: false,
  allowPlanCoverEdits: false,
  allowClauseEdits: false,
  allowGroupPolicy: false,
  allowEndorsement: false,
  allowEndorsementCostEdits: false,
  allowPolicyCorrection: false,
};

export const drawerSections: IDynamicFormWidgetSection[] = [
  {
    inputs: {
      editableLineCharges: {
        name: 'editableLineCharges',
        title: 'Editable Line Charges',
        type: FormFieldType.multiSelect,
        placeholder: 'Editable Line Charges',
        selectOptions: {},
        value: !isEmpty(initialValues.editableLineCharges)
          ? [initialValues.editableLineCharges]
          : [],
      },
      allowPolicyEndDateEdits: {
        name: 'allowPolicyEndDateEdits',
        title: 'Allow Policy End Date Edits',
        placeholder: 'Allow Policy End Date Edits',
        type: FormFieldType.switch,
        value: initialValues.allowPolicyEndDateEdits,
        required: true,
        disabled: false,
      },
      allowPlanCoverEdits: {
        name: 'allowPlanCoverEdits',
        title: 'Allow Plan Cover Details Edits',
        placeholder: 'Allow Plan Cover Details Edits',
        type: FormFieldType.switch,
        value: initialValues.allowPlanCoverEdits,
        required: true,
        disabled: false,
      },
      allowClauseEdits: {
        name: 'allowClauseEdits',
        title: 'Allow Clause Edits',
        placeholder: 'Allow Clause Edits',
        type: FormFieldType.switch,
        value: initialValues.allowClauseEdits,
        required: true,
        disabled: false,
      },
      allowGroupPolicy: {
        name: 'allowGroupPolicy',
        title: 'Allow Group Policy',
        placeholder: 'Allow Group Policy',
        type: FormFieldType.switch,
        value: initialValues.allowGroupPolicy,
        required: true,
        disabled: false,
      },
      allowEndorsement: {
        name: 'allowEndorsement',
        title: 'Allow Endorsement',
        placeholder: 'Allow Endorsement',
        type: FormFieldType.switch,
        value: initialValues.allowEndorsement,
        required: true,
        disabled: false,
      },
      allowEndorsementCostEdits: {
        name: 'allowEndorsementCostEdits',
        title: 'Allow Endorsement Cost Edits',
        placeholder: 'Allow Endorsement Cost Edits',
        type: FormFieldType.switch,
        value: initialValues.allowEndorsementCostEdits,
        required: true,
        disabled: false,
      },
      allowPolicyCorrection: {
        name: 'allowPolicyCorrection',
        title: 'Allow Policy Correction',
        placeholder: 'Allow Policy Correction',
        type: FormFieldType.switch,
        value: initialValues.allowPolicyCorrection,
        required: true,
        disabled: false,
      },
    },
  },
];
